export default __webpack_public_path__ + "static/3-85d2a5e3613f4c2a2485fea8ee75da5c.png";